import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import Dropdown from '../components/Dropdown';
import { getPoByOrderId, getPrintingPo } from '../Path/Path';
import { goodSummaryData, ibtData } from './StaticData/IBT';

const GiSummary = () => {
    const [poList, setPoList] = useState([])
    const [poData, setPoData] = useState([])
    const [poDataList, setPoDataList] = useState([])
    const [invoiceList, setInvoiceList] = useState([])
    const [tableData, setTableData] = useState({})
    const [poNumberVal, setpoNumberVal] = useState('')
    const [run, setRun] = useState(false)
    const [invoiceNumberVal, setinvoiceNumberVal] = useState('')
    useEffect(() => {
        // 
    }, []);
    useEffect(() => {
        async function fetchData() {

            const getPo = await getPrintingPo()
            let poList = getPo?.map((item => item?.po_number))
            let inList = getPo?.map((item => item?.SKU_original))
            console.log(getPo);
            const filterPoList = poList.filter(function (item, pos) {
                return poList.indexOf(item) == pos;
            })
            await setPoList(filterPoList)
            await setPoList(filterPoList)

        }
        fetchData();
    }, []);
    const apiHandler = async () => {
       await axios({
            method: "post",
            url: "https://inno-retail-web-qa.azurewebsites.net/api/1.0.0/stockCountRecords/getgoodsstoreDetails/",
            data: "draw=1&columns%5B0%5D%5Bdata%5D=date&columns%5B0%5D%5Bname%5D=&columns%5B0%5D%5Bsearchable%5D=true&columns%5B0%5D%5Borderable%5D=true&columns%5B0%5D%5Bsearch%5D%5Bvalue%5D=&columns%5B0%5D%5Bsearch%5D%5Bregex%5D=false&columns%5B1%5D%5Bdata%5D=refno&columns%5B1%5D%5Bname%5D=&columns%5B1%5D%5Bsearchable%5D=true&columns%5B1%5D%5Borderable%5D=true&columns%5B1%5D%5Bsearch%5D%5Bvalue%5D=&columns%5B1%5D%5Bsearch%5D%5Bregex%5D=false&columns%5B2%5D%5Bdata%5D=retail_item_batch_id&columns%5B2%5D%5Bname%5D=&columns%5B2%5D%5Bsearchable%5D=true&columns%5B2%5D%5Borderable%5D=false&columns%5B2%5D%5Bsearch%5D%5Bvalue%5D=&columns%5B2%5D%5Bsearch%5D%5Bregex%5D=false&columns%5B3%5D%5Bdata%5D=supplier_number&columns%5B3%5D%5Bname%5D=&columns%5B3%5D%5Bsearchable%5D=true&columns%5B3%5D%5Borderable%5D=false&columns%5B3%5D%5Bsearch%5D%5Bvalue%5D=&columns%5B3%5D%5Bsearch%5D%5Bregex%5D=false&columns%5B4%5D%5Bdata%5D=shipment_number&columns%5B4%5D%5Bname%5D=&columns%5B4%5D%5Bsearchable%5D=true&columns%5B4%5D%5Borderable%5D=true&columns%5B4%5D%5Bsearch%5D%5Bvalue%5D=&columns%5B4%5D%5Bsearch%5D%5Bregex%5D=false&columns%5B5%5D%5Bdata%5D=store&columns%5B5%5D%5Bname%5D=&columns%5B5%5D%5Bsearchable%5D=true&columns%5B5%5D%5Borderable%5D=false&columns%5B5%5D%5Bsearch%5D%5Bvalue%5D=&columns%5B5%5D%5Bsearch%5D%5Bregex%5D=false&columns%5B6%5D%5Bdata%5D=purchase_order&columns%5B6%5D%5Bname%5D=&columns%5B6%5D%5Bsearchable%5D=true&columns%5B6%5D%5Borderable%5D=true&columns%5B6%5D%5Bsearch%5D%5Bvalue%5D=&columns%5B6%5D%5Bsearch%5D%5Bregex%5D=false&columns%5B7%5D%5Bdata%5D=epc&columns%5B7%5D%5Bname%5D=&columns%5B7%5D%5Bsearchable%5D=true&columns%5B7%5D%5Borderable%5D=true&columns%5B7%5D%5Bsearch%5D%5Bvalue%5D=&columns%5B7%5D%5Bsearch%5D%5Bregex%5D=false&columns%5B8%5D%5Bdata%5D=remarks&columns%5B8%5D%5Bname%5D=&columns%5B8%5D%5Bsearchable%5D=true&columns%5B8%5D%5Borderable%5D=true&columns%5B8%5D%5Bsearch%5D%5Bvalue%5D=&columns%5B8%5D%5Bsearch%5D%5Bregex%5D=false&columns%5B9%5D%5Bdata%5D=id&columns%5B9%5D%5Bname%5D=&columns%5B9%5D%5Bsearchable%5D=true&columns%5B9%5D%5Borderable%5D=true&columns%5B9%5D%5Bsearch%5D%5Bvalue%5D=&columns%5B9%5D%5Bsearch%5D%5Bregex%5D=false&columns%5B10%5D%5Bdata%5D=comments&columns%5B10%5D%5Bname%5D=&columns%5B10%5D%5Bsearchable%5D=true&columns%5B10%5D%5Borderable%5D=true&columns%5B10%5D%5Bsearch%5D%5Bvalue%5D=&columns%5B10%5D%5Bsearch%5D%5Bregex%5D=false&order%5B0%5D%5Bcolumn%5D=0&order%5B0%5D%5Bdir%5D=desc&start=0&length=25&search%5Bvalue%5D=&search%5Bregex%5D=false&store_id=0001002&RetailItemBatchId=&from_my_date=2022-04-04&to_my_date=2022-09-19",
            referrerPolicy: "no-referrer",
            headers: {
                "accept": "application/json, text/javascript, */*; q=0.01",
                "accept-language": "en-GB,en-US;q=0.9,en;q=0.8",
                "content-type": "application/x-www-form-urlencoded; charset=UTF-8",
                "sec-ch-ua": "\"Chromium\";v=\"104\", \" Not A;Brand\";v=\"99\", \"Google Chrome\";v=\"104\"",
                "sec-ch-ua-mobile": "?0",
                "sec-ch-ua-platform": "\"macOS\"",
                "sec-fetch-dest": "empty",
                "sec-fetch-mode": "cors",
                "sec-fetch-site": "same-origin",
                "x-requested-with": "XMLHttpRequest",
                "cookie": "ORG_NAME=rubaiyat; connect.sid=s%3AnEjk4H5uSnKJeyJ_HJGoCFUH79lTH3sZ.%2B0MXOKe4nZyo9GQvkxkudZqHnhNG77SqGpoMwavWi2Q; username=null; password=null; Rememberme=null"
              },
          })
            .then(function (response) {
              //handle success
              console.log(response);
            })
            .catch(function (response) {
              //handle error
              console.log(response);
            });
    }
    const poNumbers = ["POAE-00046315",

        "POAE-00043888",

        "POAE-00043872",

        "TOAE-00017535",

        "TOAE-00017537"]
    const poHandler = (data) => {
        setpoNumberVal(data)
        setPoDataList(poData.filter((item => item.po_number === data)))
        console.log(poData.filter((item => item.po_number === data)));
        console.log(data);
    }
    const runHandler = () => {

        if (poNumberVal === '' && invoiceNumberVal === '') {
            toast.error("Please Enter Po number or Invoice number")
        } else {
            const body = {
                "order_id": poNumberVal,
                "invoice_number": invoiceNumberVal
            }
            const response = getPoByOrderId(body)
            console.log(response, 'response');

        }


    }

    return (
        <>
            <iframe id="printf" name="printf" style={{ display: 'none' }} ></iframe>
            <div className='dashboard-main'>
                <div className='dashboard-top' style={{ display: 'flex', flexDirection: 'column', padding: '10px' }} >
                    <div>
                        <p className='stock-count' style={{ fontSize: '25px', margin: 0 }}>Goods Summary</p>
                    </div>
                    <div>
                        <h1 style={{ color: 'black', fontSize: '15px' }}>
                            {new Date().toLocaleString('hi-IN')}
                        </h1>
                    </div>


                </div>
                <div className='dashboard-bottom' style={{ marginTop: "0.5%" }}>
                    <div style={{ display: "flex", width: '100%', gridColumnGap: '20px', justifyContent: 'space-between' }}>
                        <div style={{ display: 'flex', gridColumnGap: '10px' }}>

                            <input
                                className='drop-input'
                                // defaultValue={invoiceNumberVal}
                                placeholder="From Date"
                                type={'date'}
                                onChange={(data) => setinvoiceNumberVal(data.target.value)}
                            />
                            <input
                                className='drop-input'
                                type={'date'}
                                // defaultValue={invoiceNumberVal}
                                placeholder="To Date"
                                // onChange={(data) => setinvoiceNumberVal(data.target.value)}
                            />
                            <Dropdown
                                value={poNumberVal}
                                list={poList}
                                placeholder="All Destination"
                                onClickList={(data) => poHandler(data)}
                            />
                            <input
                                className='drop-input'
                                type={'text'}
                                // defaultValue={invoiceNumberVal}
                                placeholder="Retail Item Batch Id"
                                onChange={(data) => setinvoiceNumberVal(data.target.value)}
                            />
                        </div>


                        <button onClick={() => runHandler()} className="run-btn"><p className="run-text">Run</p></button>
                    </div>
                    <div style={{ marginTop: '20px', overflow: 'auto', height: '600px' }}>
                        <table data-table-theme="dark zebra">
                            <thead>
                                <tr style={{ background: "#373E43" }}>
                                    <th >Store</th>
                                    <th>Retail Item Batch Id </th>
                                    <th>Item Count </th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    goodSummaryData.aaData.splice(0, 11).map((data, index) =>
                                        <tr>
                                            <td>{data.store}</td>
                                            <td onClick={(e) => apiHandler(e)} dangerouslySetInnerHTML={{ __html: data.retail_item_batch_id }}></td>
                                            <td dangerouslySetInnerHTML={{ __html: data.item_count }}></td>
                                        </tr>
                                    )
                                }
                            </tbody>
                        </table>
                    </div>

                </div>
            </div>
        </>
    )
}

export default GiSummary;
